import { extractHashtagsWithIndices } from '@draft-js-plugins/hashtag';
import {
    DefaultButton,
    Dialog,
    DirectionalHint,
    Icon,
    IconButton,
    IContextualMenuItem,
    IContextualMenuProps,
    IIconProps,
    ITooltipHostStyles,
    ITooltipProps,
    Link,
    Modal,
    Pivot,
    PivotItem,
    PrimaryButton,
    Spinner,
    SpinnerSize,
    Text,
    TextField,
    Toggle,
    TooltipDelay,
    TooltipHost
} from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import AddAttachmentModal from 'app/components/addAttachmentModal/AddAttachmentModal';
import AddImpact from 'app/components/addCustomer/AddCustomer';
import AddCustomerSurface from 'app/components/addCustomer/AddCustomerSurface';
import AddCustomerSuccessToast from 'app/components/addCustomer/AddCustomerSuccessToast/AddCustomerSuccessToast';
import { resolveCustomerImpactSuccess } from 'app/components/addCustomer/customerImpactSuccess';
import RemoveCustomerDialog from 'app/components/removeCustomerDialog/RemoveCustomerDialog';
import Button from 'app/components/button/Button';
import CommentSection from 'app/components/commentSection/CommentSection';
import {
    filterField,
    formatHashtags,
    GetText,
    highlightTags,
    injectTargetToAnchor,
    ISOToDateTime,
    keyPress,
    ReplaceUrlByAnchor,
    requestAggregateSubmit,
    getURLForTeamAndType
} from 'app/components/helpers';
import LinkChildrenModal from 'app/components/linkChildrenModal/LinkChildrenModal';
import { Loader } from 'app/components/loader/Loader';
import ShareRequestModal from 'app/components/shareRequestModal/ShareRequestModal';
import StatusSection from 'app/components/statusSection/StatusSection';
import { unifiedDashboardCardsList } from 'app/models/common/enumerators';
import { IAddCustomer } from 'app/models/common/post';
import { formatCustomerNames, GetTypes } from 'app/components/helpers';
import { formatCustomerSummary } from 'app/modules/newTicketView/customerDisplay';
import { resolveCustomerSummaryText } from 'app/modules/newTicketView/generalFeedback';
import { useIsNewTicketViewEnabled } from 'app/modules/newTicketView/viewFlag';
import { IAttachmentUpdateData, IRemoveCustomerImpactData, IRequestParams } from 'app/models/common/request';
import { IUserProps } from 'app/models/common/response';
import { AppQueryClient } from 'app/services/clients/query-client';
import {
    usePostRequestType,
    useRemoveCustomerImpact,
    useUpdateRequest,
    usePostCommentsHashTags,
} from 'app/services/mutations';
import {
    useRequestList,
    useGetCountries,
    useGetRequestById,
    useAddTagRequest,
    useGetTagsList,
    useAddBookmark,
    useRemoveBookmark,
    useUpdateStatus,
    useUpdateRequestDevices,
    useAssociateRequests,
 } from 'app/services/request-api';
import {
    BugInformations,
    CompanyInformationDto,
    CountryMaster,
    Criticality,
    CustomerImpactDto,
    DeviceModelDto,
    EnumLookUp,
    HashTagDto,
    IAssociateRequestsDto,
    ICompanyInformationDto,
    IEditDevicesDto,
    IEditStatusDto,
    ImpactReach,
    IUpdateRequestDto,
    MainRequestType,
    PaginatedListOfRequestDto,
    PFRSubtype,
    Priority,
    ProductCategory,
    RequestAction,
    RequestDto,
    RequestStatus,
    RequestTypeDetailsDto,
    SubRequestType,
    TagDto,
    TaskStatus
} from 'generated/request-backend';
import { useFetchUsersListByRole } from 'app/services/user-api';
import useStore, { IStore } from 'app/store';
import { Entity, BlobStorageContainer, StringConstants } from 'app/utils/constants';
import { UserDomain } from 'app/enums/UserDomain.enum';

import { attachmentCounter, getPortalValue } from 'app/utils/utilities';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AssignedToFilter from '../manageRequests/filterPanel/assignedToFilter/AssignedToFilter';
import { EllipseMenu } from '../triageMenu/EllipseMenu';
import AssociationTab from './associationTab/AssociationTab';
import CustomerDetailsTab from './customerDetailsTab/CustomerDetailsTab';
import ConfidentialIdentifier from './requestDetailsTab/ConfidentialIdentifier';
import DetailCard from './requestDetailsTab/DetailCard';
import './DetailsPanel.scss';
import RequestDetailsTab from './requestDetailsTab/RequestDetailsTab';
import RequestRichTextEditor from './requestRichTextEditor/RequestRichTextEditor';
import TagsList from './tagsList/TagsList';
import { addBlobFileSasToken } from 'app/utils/blobStorageHelpers';
import { ICustomerImpactDto } from 'generated/crew-backend';
import { CustomerImpactResponseDto, IRequestDto } from 'generated/cxp-backend';
import DOMPurify from 'dompurify';
import { logFlowEvent } from 'app/modules/user/createTicket/flowTelemetry';
import { ViewTelemetryConstants, VIEW_TELEMETRY_SECTION } from 'app/modules/newTicketView/telemetryConstants';

const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: 'inline-block', borderRadius: '13px' }
};

const DetailsPanel = (props: {
    selectedRequest: RequestDto;
    requestTypes: EnumLookUp[];
    statusTypes: EnumLookUp[];
    associationTypes: EnumLookUp[];
    setIsAddCustomerModalOpen?: Function;
    teams: EnumLookUp[];
    isEditMode?: boolean;
    setIsEditMode?: (value: boolean) => void;
    setSelectedRequest?: (request: RequestDto) => void;
    requestData?: RequestDto[];
    setRequestData?: Function;
    setPageNumber?: (value: number) => void;
    isLoading?: boolean;
    pageNumber?: number;
    onRefetchHandler?: Function;
    requestDetailsLookup?: RequestTypeDetailsDto[];
    pageType?: string;
}) => {
    const {
        selectedRequest,
        statusTypes,
        associationTypes,
        isEditMode,
        isLoading,
        pageNumber,
        requestDetailsLookup,
        setIsEditMode,
        setSelectedRequest,
        setPageNumber,
        pageType
    } = props;

    // state variables
    const [isMissingModalOpen, { setTrue: showMissingModal, setFalse: hideMissingModal }] = useBoolean(false);
    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const history = useHistory();
    const portal = getPortalValue(history?.location?.pathname);
    const isNewTicketViewEnabled = useIsNewTicketViewEnabled();
    const [attachmentCount, setAttachmentCount] = useState<number>(0);
    const [selectedTab, setSelectedTab] = useState('REQUEST_DETAILS');
    const [missingDetails, setMissingDetails] = useState<string[]>([]);
    const [options, setOptions] = useState<IUserProps[]>([]);
    const [assignedToSelection, setAssignedToSelection] = useState<IUserProps[]>([]);
    const [resolutionDate, setResolutionDate] = useState<Date>();

    // state variables for rich text editor
    const [descriptionTextToSubmit, setDescriptionTextToSubmit] = useState<string>('');
    const [dateImportantTextToSubmit, setDateImportantTextToSubmit] = useState<string>('');

    const [statusSelection, setStatusSelection] = useState(0);
    const [isAddAttachmentModalOpen, setIsAddAttachmentModalOpen] = useState(false);
    const [isLinkRequestModalOpen, setIsLinkRequestModalOpen] = useState(false);
    const [isAssociatingParent, setIsAssociatingParent] = useState<boolean>(false);
    const [hideDialog, { toggle: toggleHideDialog, setTrue: hideRemoveDialog }] = useBoolean(true);
    const [impactForRemoval, setImpactForRemoval] = useState<IRemoveCustomerImpactData>({});
    const [removeCustomerError, setRemoveCustomerError] = useState(false);
    const [isInvalidTitle, setIsInvalidTitle] = useState(false);
    const [isInvalidDescription, setIsInvalidDescription] = useState(false);
    const [hideUpdateLoaderDialog, { toggle: toggleUpdateLoaderHideDialog }] = useBoolean(true);
    const userDetails = useStore((state: IStore) => state.userDetails);
    const [isShareRequestModalOpen, setIsShareRequestModalOpen] = useState(false);
    const [isShowComment, setIsShowComment] = useState(true);
    const [countyCodePrefix, setCountryCodePrefix] = useState({ contactNumber: '', alternateContactNumber: '' });
    const [parentRequest, setParentRequest] = useState<RequestDto | null>(null);

    useEffect(() => {
        if (isNewTicketViewEnabled && selectedRequest?.confidentialIdentifier?.trim()) {
            logFlowEvent(
                ViewTelemetryConstants.CONFIDENTIAL_IDENTIFIER_VIEWED,
                VIEW_TELEMETRY_SECTION,
                {
                    role: 'admin',
                    requestType: selectedRequest.requestType
                }
            );
        }
    }, [isNewTicketViewEnabled, selectedRequest?.confidentialIdentifier, selectedRequest?.requestType]);

    // data variable used for edit
    const [title, setTitle] = useState('');
    const [titleFieldValue, setTitleFieldValue] = useState<string>('');
    const [editableFields, setEditableFields] = useState({});
    const [isUpdateTriggered, setIsUpdateTriggered] = useState(false);
    const [isShowLoader, setIsShowLoader] = useState(true);
    const [whatBusinessProblemIsSolved, setWhatBusinessProblemIsSolved] = useState('');
    const [competitiveOffering, setCompetitiveOffering] = useState('');
    const [isDesignForSurfaceDFSPossible, setIsDesignForSurfaceDFSPossible] = useState('');
    const [dcfJustification, setDcfJustification] = useState('');
    const [dcfApprovedValue, setDcfApprovedValue] = useState(null);
    const [customerDetailsValidation, setCustomerDetailsValidation] = useState({
        emailValidText: false,
        contactNumberValidText: false,
        alternateContactValidText: false
    });
    const [dcfSR, setDcfSR] = useState('');
    const [cssCaseNumber, setCssCaseNumber] = useState('');
    const [answer, setAnswer] = useState('');
    const [companyInformation, setCompanyInformation] = useState<ICompanyInformationDto>({});
    const [isStarred, setIsStarred] = useState(false);

    const { data: countryList } = useGetCountries();
    const {
        mutate: addBookmark,
        isLoading: isLoadingAddBookmark,
        isSuccess: isSuccessAddBookmark,
        isError: isErrorAddBookMark
    } = useAddBookmark();
    const {
        mutate: removeBookmark,
        isLoading: isLoadingRemoveBookmark,
        isSuccess: isSuccessRemoveBookmark,
        isError: isErrorRemoveBookmark
    } = useRemoveBookmark();
    const { mutate: addTagMutate } = useAddTagRequest();
    const [tagsListData, setTagsListData] = useState<TagDto[]>([]);
    const [selectedTags, setSelectedTags] = useState<TagDto[]>([]);

    const [isUpdateErrorModalOpen, { setTrue: showUpdateErrorModal, setFalse: hideUpdateErrorModal }] = useBoolean(false);

    const onToggleBookmark = () => {
        if (isStarred) {
            removeBookmark(selectedRequest.unifiedTrackingId);
        } else {
            addBookmark(selectedRequest.unifiedTrackingId);
        }
    };

    const pageSize = 500;

    const [criteria, setCriteria] = useState<IRequestParams>({
        from: '2001-01-01T00:00:00Z',
        to: '9999-12-31T23:59:59Z',
        pageNumber: 1,
        pageSize: pageSize,
        type: unifiedDashboardCardsList.ALL_REQUEST,
        requestType: [],
        parentRequestId: undefined,
        portal: portal
    });

    const [correlatedChildrenIds, setCorrelatedChildrenIds] = useState<string[]>([]);
    const { data: usersListData, isLoading: isUserListLoading } = useFetchUsersListByRole(selectedRequest?.requestTeam);

    const { data: tagsData, isLoading: isTagsLoading } = useGetTagsList();

    useGetRequestById(selectedRequest?.isParent ? selectedRequest?.unifiedTrackingId : selectedRequest?.parentRequestId, {
        enabled:
            selectedRequest !== undefined && (selectedRequest?.parentRequestId !== '' || selectedRequest?.parentRequestId !== null),
        onSuccess: (response) => {
            if (response !== undefined) {
                setParentRequest(response);
                setCriteria({ ...criteria, parentRequestId: response.unifiedTrackingId });
            }
        }
    });

    useRequestList(criteria, {
        enabled: criteria !== undefined && criteria.parentRequestId !== undefined,
        onSuccess: (response: PaginatedListOfRequestDto) => {
            setCorrelatedChildrenIds(response.items.map((item: RequestDto) => item.unifiedTrackingId));
        }
    });

    // queries
    const { mutate: removeCustomerImpactMutation, isLoading: isRemovingCustomer } = useRemoveCustomerImpact();

    // helper functions
    const handleModalDismiss = () => {
        hideMissingModal();
        setMissingDetails([]);
    };
    const renderTag = (status: number) => {
        let label = '';
        let tagClass = '';
        switch (status) {
            case 1:
                label = GetText(statusTypes, status);
                tagClass = 'tag-type-a';
                break;
            case 2:
                label = GetText(statusTypes, status);
                tagClass = 'tag-type-b';
                break;
            case 3:
                label = GetText(statusTypes, status);
                tagClass = 'tag-type-c';
                break;
            case 4:
                label = GetText(statusTypes, status);
                tagClass = 'tag-type-d';
                break;
            case 5:
                label = GetText(statusTypes, status);
                tagClass = 'tag-type-e';
                break;
            default:
                tagClass = 'tag-type-a';
                break;
        }
        return <Text className={`quick-tag ${tagClass}`}>{label}</Text>;
    };

    const renderAssociationTag = () => {
        let label = '';
        let tagClass = '';
        if (selectedRequest.isParent) {
            label = GetText(associationTypes, 2);
            tagClass = 'tag-type-f';
        }

        //Renders a child tag on the associated request
        if (selectedRequest.parentRequestId !== null && selectedRequest.parentRequestId !== '') {
            label = GetText(associationTypes, 3);
            tagClass = 'tag-type-g';
        }

        return <Text className={`quick-tag ${tagClass}`}>{label}</Text>;
    };

    const handleCancelEdit = () => {
        setIsEditMode(false);
        setIsInvalidDescription(false);
        setIsInvalidTitle(false);
    };

    const [hideLoadingScreen, setHideLoadingScreen] = useState(false);

    const handleAddProduct = () => {
        setIsShowLoader(true);
        toggleUpdateLoaderHideDialog();
        
        const deviceModels: DeviceModelDto[] = [];
        selectedRequest.deviceModels.forEach(device => {
            deviceModels.push(new DeviceModelDto({...device}));
        });

        const devicesToUpdate: IEditDevicesDto = { id: selectedRequest.unifiedTrackingId, devices: deviceModels };

        updateRequestDevicesMutation(devicesToUpdate);
    }

    const handleSaveRequest = () => {
        // Add the validations on edit here
        let customerDetailsValidationDetails = { ...customerDetailsValidation };
        let flag = false;
        let customerDetailFlag = false;

        if (descriptionTextToSubmit.trim() === '') {
            flag = true;
            setIsInvalidDescription(true);
        }
        if (title.trim() === '') {
            flag = true;
            setIsInvalidTitle(true);
        }
        if (
            companyInformation?.contactEmailAddress &&
            companyInformation?.contactEmailAddress.trim() !== '' &&
            !companyInformation?.contactEmailAddress.trim().match(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/)
        ) {
            flag = true;
            customerDetailFlag = true;
            customerDetailsValidationDetails = { ...customerDetailsValidationDetails, emailValidText: true };
            if (selectedTab !== StringConstants.CUSTOMER_INFORMATION) {
                setMissingDetails([...missingDetails, 'Customer email ID']);
            }
        }

        if (
            companyInformation?.contactPhoneNumber &&
            companyInformation?.contactPhoneNumber?.trim() !== '' &&
            (!companyInformation?.contactPhoneNumber?.trim().match(/^\d{3,20}$/) ||
                !countyCodePrefix.contactNumber ||
                countyCodePrefix.contactNumber?.trim() === '')
        ) {
            flag = true;
            customerDetailFlag = true;
            customerDetailsValidationDetails = { ...customerDetailsValidationDetails, contactNumberValidText: true };
            if (selectedTab !== StringConstants.CUSTOMER_INFORMATION) {
                setMissingDetails([...missingDetails, 'Contact number']);
            }
        }
        if (
            companyInformation?.alternateContactNumber &&
            companyInformation?.alternateContactNumber?.trim() !== '' &&
            (!companyInformation?.alternateContactNumber?.trim().match(/^\d{3,20}$/) ||
                !countyCodePrefix.alternateContactNumber ||
                countyCodePrefix.alternateContactNumber?.trim() === '')
        ) {
            flag = true;
            customerDetailFlag = true;
            customerDetailsValidationDetails = { ...customerDetailsValidationDetails, alternateContactValidText: true };
            if (selectedTab !== StringConstants.CUSTOMER_INFORMATION) {
                setMissingDetails([...missingDetails, 'Alternative contact number']);
            }
        }
        setCustomerDetailsValidation({ ...customerDetailsValidationDetails });
        if (customerDetailFlag && selectedTab !== StringConstants.CUSTOMER_INFORMATION) {
            showMissingModal();
        }
        if (flag) {
            return false;
        }
        let companyInfo: ICompanyInformationDto = { ...companyInformation };
        if (companyInformation.contactPhoneNumber && companyInformation.contactPhoneNumber.trim() !== '') {
            companyInfo.contactPhoneNumber = countyCodePrefix.contactNumber + ' ' + companyInfo.contactPhoneNumber;
        }
        if (companyInformation.alternateContactNumber && companyInformation.alternateContactNumber.trim() !== '') {
            companyInfo.alternateContactNumber =
                countyCodePrefix.alternateContactNumber + ' ' + companyInformation.alternateContactNumber;
        }
        setIsUpdateTriggered(true);
        setIsShowLoader(true);

        let updatedCssNumber = selectedRequest.cssCaseNumber ? selectedRequest.cssCaseNumber : cssCaseNumber;
        setEditableFields((value: RequestDto) => ({
            ...value,
            ...{
                summary: title,
                description: descriptionTextToSubmit,
                requestedResolutionDate: moment.utc(resolutionDate).isValid() ? moment.utc(resolutionDate).format() : null,
                status: statusSelection,
                whatBusinessProblemIsSolved: whatBusinessProblemIsSolved,
                competitiveOffering: competitiveOffering,
                isDesignForSurfacedPossible: isDesignForSurfaceDFSPossible,
                dcfJustification: dcfJustification,
                dcfApprovedValue: dcfApprovedValue,
                dcfSR: dcfSR,
                cssCaseNumber: updatedCssNumber,
                answer: answer,
                whyThisDateIsImportant: dateImportantTextToSubmit,
                companyInformation: companyInfo,
                deviceModels: selectedRequest.deviceModels
            },
            hashTags: formatHashtags(
                Array.from(
                    new Set([
                        ...extractHashtagsWithIndices(dateImportantTextToSubmit).map((tags) => tags.hashtag),
                        ...extractHashtagsWithIndices(descriptionTextToSubmit).map((tags) => tags.hashtag)
                    ])
                )
            )
        }));
    };

    const generateEditData = () => {
        let IEditedData: IRequestDto = {};
        IEditedData = { ...IEditedData, ...editableFields };
        let IFilteredData: IRequestDto = {};
        for (const key in IEditedData) {
            if (filterField(key, selectedRequest.requestType)) {
                IFilteredData = { ...IEditedData, [key as keyof IRequestDto]: IEditedData[key as keyof IRequestDto] };
            }
        }

        if (selectedRequest.unifiedTrackingId) {
            IFilteredData.status =
                selectedRequest.status;
        }

        let selectedRequestTempObj = new RequestDto(); 
        selectedRequestTempObj.init(selectedRequest);

        if (selectedRequestTempObj.unifiedTrackingId) {
            delete selectedRequestTempObj.unifiedTrackingId;
            // setSelectedRequest(selectedRequestTempObj);
        }

        IFilteredData.id = selectedRequest.unifiedTrackingId
            ? selectedRequest.unifiedTrackingId
            : selectedRequest.unifiedTrackingId;
        IFilteredData.requestTeam = selectedRequest.requestTeam;
        IFilteredData.requestType = selectedRequest.requestType;
        IFilteredData.deviceModels = selectedRequest.deviceModels;

        const returnData = new RequestDto({...IFilteredData});
        returnData.init(IFilteredData);
        return returnData;
    };

    const sanitizeValue = (value: string | number | boolean | BugInformations[] | HashTagDto[]) => {
        if (value === undefined || value === null || value === '') {
            return null;
        } else {
            return value;
        }
    };

    const getContactNumber = (value: string) => {
        let val = value.split(' ');
        if (val && val.length === 2) return val[1];
        else if (val && val.length > 2) {
            let formattedNumber = '';
            val.forEach((item: string, index: number) => {
                if (index !== 0) formattedNumber += item;
            });
            return formattedNumber;
        }
        return value;
    };

    const getCountryCode = (value: string) => {
        if (!value) return null;

        let val = value.split(' ');
        if (countryList) {
            let list: CountryMaster[] = countryList;
            var dialingCodeItems = list.filter((x) => x.dialingCode === val[0]);
            if (dialingCodeItems && dialingCodeItems.length > 0) {
                return dialingCodeItems[0].dialingCode;
            }
            return null;
        }
        return null;
    };

    const initializeEditData = () => {
        let fieldData: RequestDto = new RequestDto();
        // these fields are mandatory
        fieldData.description = selectedRequest?.description;
        fieldData.requestedResolutionDate = selectedRequest?.requestedResolutionDate != null && moment.utc(selectedRequest?.requestedResolutionDate).isValid()
            ? moment.utc(selectedRequest?.requestedResolutionDate).toDate()
            : null;
        fieldData.status = sanitizeValue(selectedRequest?.status) as RequestStatus;
        // these fields are optional
        fieldData.criticality = sanitizeValue(selectedRequest?.criticality) as Criticality;
        fieldData.impactReach = sanitizeValue(selectedRequest?.impactReach) as ImpactReach;
        fieldData.productCategory = sanitizeValue(selectedRequest?.productCategory) as ProductCategory;
        fieldData.approvedMessaging = sanitizeValue(selectedRequest?.approvedMessaging) as string;
        fieldData.whatBusinessProblemIsSolved = sanitizeValue(selectedRequest?.whatBusinessProblemIsSolved) as string;
        fieldData.competitiveOffering = sanitizeValue(selectedRequest?.competitiveOffering) as string;
        fieldData.isDesignForSurfacedPossible = sanitizeValue(selectedRequest?.isDesignForSurfacedPossible) as string;
        fieldData.pfrSubType = sanitizeValue(selectedRequest?.pfrSubType) as PFRSubtype;
        fieldData.bugInformations = sanitizeValue(selectedRequest?.bugInformations) as BugInformations[];
        fieldData.bugNumber = sanitizeValue(selectedRequest?.bugNumber) as string;
        fieldData.priority = sanitizeValue(selectedRequest?.priority) as Priority;
        fieldData.mainRequestType = sanitizeValue(selectedRequest?.mainRequestType) as MainRequestType;
        fieldData.subRequestType = sanitizeValue(selectedRequest?.subRequestType) as SubRequestType;
        fieldData.taskStatus = sanitizeValue(selectedRequest?.taskStatus) as TaskStatus;
        fieldData.isDcfRequest = sanitizeValue(selectedRequest?.isDcfRequest) as boolean;
        fieldData.dcfJustification = sanitizeValue(selectedRequest?.dcfJustification) as string;
        fieldData.isBlockingSale = sanitizeValue(selectedRequest?.isBlockingSale) as boolean;
        fieldData.isDcfApproved = sanitizeValue(selectedRequest?.isDcfApproved) as boolean;
        fieldData.proofOfPurchaseAttached = sanitizeValue(selectedRequest?.proofOfPurchaseAttached) as boolean;
        fieldData.serialNumbersAttached = sanitizeValue(selectedRequest?.serialNumbersAttached) as boolean;
        fieldData.dcfApprovedValue = sanitizeValue(selectedRequest?.dcfApprovedValue) as number;
        fieldData.dcfSR = sanitizeValue(selectedRequest?.dcfSR) as string;
        fieldData.cssCaseNumber = sanitizeValue(selectedRequest?.cssCaseNumber) as string;
        fieldData.answer = sanitizeValue(selectedRequest?.answer) as string;
        fieldData.whyThisDateIsImportant = sanitizeValue(selectedRequest?.whyThisDateIsImportant) as string;
        fieldData.hashTags = sanitizeValue(selectedRequest?.hashTags) as HashTagDto[];
        let companyInfo : ICompanyInformationDto = {
            companyContactName:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyContactName
                    ? selectedRequest?.companyInformation.companyContactName
                    : null,
            companyFullShippingAddress:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyFullShippingAddress
                    ? selectedRequest?.companyInformation.companyFullShippingAddress
                    : null,
            companyName:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyName
                    ? selectedRequest?.companyInformation.companyName
                    : null,
            contactEmailAddress:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.contactEmailAddress
                    ? selectedRequest?.companyInformation.contactEmailAddress
                    : null,
            contactPhoneNumber:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.contactPhoneNumber
                    ? getContactNumber(selectedRequest?.companyInformation.contactPhoneNumber)
                    : null,
            alternateContactNumber:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.alternateContactNumber
                    ? getContactNumber(selectedRequest?.companyInformation.alternateContactNumber)
                    : null
        };
        fieldData.companyInformation = new CompanyInformationDto(companyInfo);
        setCountryCodePrefix({
            contactNumber: getCountryCode(selectedRequest?.companyInformation?.contactPhoneNumber),
            alternateContactNumber: getCountryCode(selectedRequest?.companyInformation?.alternateContactNumber)
        });
        setCompanyInformation(companyInfo);

        fieldData.summary = sanitizeValue(selectedRequest?.summary) as string;
        setEditableFields(fieldData);
    };

    const onActionDropdownChangeHandler = (fieldName: string, fieldValue: number | boolean | string) => {
        if(typeof fieldValue === 'string' && parseInt(fieldValue)) {
            fieldValue = parseInt(fieldValue);
        } else if(typeof fieldValue === 'string' && (fieldValue.toLowerCase() === 'true' || fieldValue.toLowerCase() === 'false')) {
            fieldValue = fieldValue.toLowerCase() === 'true' ? true : false;
        }
        setIsUpdateTriggered(false);
        setIsShowLoader(true);
        let fieldData: RequestDto = new RequestDto();
        fieldData.init(selectedRequest);
        switch (fieldName) {
            case 'productCategory':
                fieldData.productCategory = fieldValue as ProductCategory;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'pfrSubtype':
                fieldData.pfrSubType = fieldValue as PFRSubtype;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'priority':
                fieldData.priority = fieldValue as Priority;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'criticality':
                fieldData.criticality = fieldValue as Criticality;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'impactReach':
                fieldData.impactReach = fieldValue as ImpactReach;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'mainRequestType':
                fieldData.mainRequestType = fieldValue as MainRequestType;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'subRequestType':
                fieldData.subRequestType = fieldValue as SubRequestType;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'taskStatus':
                fieldData.taskStatus = fieldValue as TaskStatus;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'isDcfRequest':
                fieldData.isDcfRequest = fieldValue as boolean;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(true);
                break;
            case 'isBlockingSale':
                fieldData.isBlockingSale = fieldValue as boolean;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'isDcfApproved':
                fieldData.isDcfApproved = fieldValue as boolean;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'proofOfPurchaseAttached':
                fieldData.proofOfPurchaseAttached = fieldValue as boolean;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;
            case 'serialNumbersAttached':
                fieldData.serialNumbersAttached = fieldValue as boolean;
                if (!isEditMode) {
                    setIsUpdateTriggered(true);
                }
                setIsShowLoader(false);
                break;

            default:
                break;
        }

        setEditableFields((value: RequestDto) => ({ ...value, ...fieldData }));
    };

    const [isStatusClosed, setIsStatusClosed] = useState(false);
    const [statusClosedSKPID, setStatusClosedSKPID] = useState('');

    const {
        mutate: updateStatusMutation,
        isSuccess: isSuccessStatusUpdate,
        isError: isErrorStatusUpdate,
        isLoading: isLoadingStatusUpdate
    } = useUpdateStatus();

    const handleStatusSelect = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem): void => {
        setStatusSelection(parseInt(item.key));
        if (!isEditMode) {
            if (selectedRequest.status === parseInt(item.key)) {
                ev.preventDefault();
                return;
            }
            setStatusClosedSKPID('');
            if (item.key === StringConstants.FIVE) {
                setStatusClosedSKPID(selectedRequest.id);
            }
            toggleUpdateLoaderHideDialog();
            setIsShowLoader(true);

            var statusUpdateObject: IEditStatusDto = {
                id: selectedRequest.unifiedTrackingId,
                status: parseInt(item.key),
                customerFamilySubmissionId: selectedRequest.customerFamilySubmissionId,
                customerFamilyGeneration: selectedRequest.customerFamilyGeneration
            };
            
            updateStatusMutation(statusUpdateObject);
        }
    };

    const getModalData = (data: RequestDto) => {
        let attachmentData: IAttachmentUpdateData = {};
        attachmentData.applicationId = data.id;
        attachmentData.attachments = data.attachments;
        attachmentData.requestId = data.unifiedTrackingId;
        attachmentData.requestType = GetTypes(data.requestType);
        attachmentData.teamName = UserDomain[data.requestTeam as number];
        attachmentData.summary = data.summary;
        attachmentData.teamValue = data.requestTeam;
        attachmentData.requestTypeValue = data.requestType;
        attachmentData.isHidden = data.isHidden;
        return attachmentData;
    };

    const handleRemoveImpactConfirm = () => {
        if (isRemovingCustomer) {
            return;
        }
        let data: ICustomerImpactDto = {
            opportunityId: impactForRemoval.opportunityId,
            accountId: impactForRemoval.accountId,
            customerName: impactForRemoval.customerName
        };
        const url = getURLForTeamAndType(selectedRequest.requestTeam, selectedRequest.requestType);
        removeCustomerImpactMutation(
            {
                url: url,
                id: selectedRequest.unifiedTrackingId,
                data: data
            },
            {
                onSuccess: () => {
                    setRemoveCustomerError(false);
                    logFlowEvent(ViewTelemetryConstants.CUSTOMER_REMOVED, VIEW_TELEMETRY_SECTION, {
                        role: 'admin',
                        requestType: selectedRequest.requestType
                    });
                    hideRemoveDialog();
                },
                onError: () => {
                    setRemoveCustomerError(true);
                    logFlowEvent(ViewTelemetryConstants.CUSTOMER_REMOVE_FAILED, VIEW_TELEMETRY_SECTION, {
                        role: 'admin',
                        requestType: selectedRequest.requestType
                    });
                }
            }
        );
    };

    const dismissRemoveCustomerDialog = () => {
        setRemoveCustomerError(false);
        logFlowEvent(ViewTelemetryConstants.REMOVE_DIALOG_DISMISSED, VIEW_TELEMETRY_SECTION, {
            role: 'admin'
        });
        hideRemoveDialog();
    };

    const onCompletedHandler = () => {
        AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
        AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
        AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
        AppQueryClient.invalidateQueries('useRequestList');
        AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
    };

    const statusMenu: IContextualMenuProps = React.useMemo(
        () => ({
            shouldFocusOnMount: true,
            className: 'admin-edit-status-menu',
            items: [
                {
                    key: "1",
                    text: 'New',
                    canCheck: true,
                    isChecked: statusSelection === 1 ? true : false,
                    onClick: handleStatusSelect
                } as IContextualMenuItem,
                {
                    key: "2",
                    text: 'Active',
                    canCheck: true,
                    isChecked: statusSelection === 2 ? true : false,
                    onClick: handleStatusSelect
                } as IContextualMenuItem,
                {
                    key: "4",
                    text: 'Resolved',
                    canCheck: true,
                    isChecked: statusSelection === 4 ? true : false,
                    onClick: handleStatusSelect
                } as IContextualMenuItem,
                {
                    key: "5",
                    text: 'Closed',
                    canCheck: true,
                    isChecked: statusSelection === 5 ? true : false,
                    onClick: handleStatusSelect
                } as IContextualMenuItem
            ]
        }),
        [handleStatusSelect, statusSelection, selectedRequest]
    );

    const { mutate: associateRequests } = useAssociateRequests();
    const { mutate: postRequestTypeHelp } = usePostRequestType();

    // State variables for addCustomer
    const [requestProcessing, setRequestProcessing] = useState(false);
    const [displayScreen, setDisplayScreen] = useState('searchCust');
    const [editCustomer, setEditCustomer] = useState<IRemoveCustomerImpactData | undefined>(undefined);
    const [toastCustomerName, setToastCustomerName] = useState('');
    const [showAddCustomerToast, setShowAddCustomerToast] = useState(false);
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);

    useEffect(() => {
        if (displayScreen === 'successPopUp') {
            hideModal();
            setDisplayScreen('searchCust');
            setShowAddCustomerToast(true);
        }
    }, [displayScreen, hideModal]);

    const handleAddCustomerSuccess = (postAddCustomerResponseData: CustomerImpactResponseDto, addedCustomerImpacts: IAddCustomer[]) => {
        setToastCustomerName(addedCustomerImpacts[0]?.customerName || 'Customer');
        const originalRequestId = selectedRequest.unifiedTrackingId;
        const successResolution = resolveCustomerImpactSuccess(
            postAddCustomerResponseData,
            originalRequestId
        );
        logFlowEvent(ViewTelemetryConstants.CUSTOMER_ADDED, VIEW_TELEMETRY_SECTION, {
            role: 'admin',
            requestType: selectedRequest.requestType,
            customerCount: addedCustomerImpacts.length,
            parentCreated: successResolution.parentCreated
        });
        if (!successResolution.matchesSelectedRequest) {
            setRequestProcessing(false);
            setDisplayScreen('errorPopUp');
            return;
        }

        if (successResolution.isStructuredFamilyResponse) {
            setRequestProcessing(false);
            setDisplayScreen('successPopUp');
            AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
            AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
            AppQueryClient.invalidateQueries('useRequestList');
            AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            return;
        }

        if (
            selectedRequest.isParent === true ||
            (selectedRequest.parentRequestId !== null && selectedRequest.parentRequestId !== '')
        ) {
            const parentRequestId = selectedRequest.isParent
                ? originalRequestId
                : selectedRequest.parentRequestId;

            if (parentRequestId !== postAddCustomerResponseData?.id) {
                const associationObject : IAssociateRequestsDto = {
                    requestIds: [postAddCustomerResponseData?.id],
                    associatedRequestId: selectedRequest.isParent
                        ? originalRequestId
                        : selectedRequest.parentRequestId,
                    expectedCustomerFamilySubmissionId: selectedRequest.customerFamilySubmissionId,
                    expectedCustomerFamilyGeneration: selectedRequest.customerFamilyGeneration
                };

                associateRequests(associationObject, {
                    onSuccess: () => {
                        setRequestProcessing(false);
                        setDisplayScreen('successPopUp');

                        AppQueryClient.invalidateQueries('getRequestById');
                        AppQueryClient.invalidateQueries('useRequestList');
                        AppQueryClient.invalidateQueries('requestQuery');
                        AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
                    },
                    onError: () => {
                        setRequestProcessing(false);
                        setDisplayScreen('errorPopUp');
                    }
                });
            } else {
                setRequestProcessing(false);
                setDisplayScreen('successPopUp');

                AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
                AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
                AppQueryClient.invalidateQueries('useRequestList');
                AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            }
        } else if (originalRequestId !== postAddCustomerResponseData?.id) {
            // aggregate parent with selectedRequest becoming aggregate parent
            let datapass : RequestDto = new RequestDto({
                summary: selectedRequest.summary,
                description: selectedRequest.description,

                requestedResolutionDate: selectedRequest.requestedResolutionDate,
                whyThisDateIsImportant: selectedRequest.whyThisDateIsImportant,

                status: 1,
                attachments: selectedRequest.attachments,
                customerImpacts: [] as CustomerImpactDto[],
                isParent: true
            });

            var aggregateCustomerImpact = [] as CustomerImpactDto[];

            selectedRequest.customerImpacts.forEach((impact) => {
                aggregateCustomerImpact.push(impact);
            });

            datapass.customerImpacts = aggregateCustomerImpact;
            datapass.status = selectedRequest.status;

            const requestAggregateData = requestAggregateSubmit(selectedRequest.requestType, selectedRequest, datapass);
            postRequestTypeHelp(
                { subUrl: requestAggregateData.subUrl, data: requestAggregateData.data },
                {
                    onSuccess: (response) => {
                        associateChildren(response, postAddCustomerResponseData?.id, originalRequestId);
                    },
                    onError: () => {
                        setRequestProcessing(false);
                        setDisplayScreen('errorPopUp');
                    }
                }
            );
        } else {
            setRequestProcessing(false);
            setDisplayScreen('successPopUp');

            AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
            AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
        }
    };

    const associateChildren = (parentId: string, postAddCustomerId: string, originalRequestId: string) => {
        const associationObject : IAssociateRequestsDto = {
            requestIds: [originalRequestId, postAddCustomerId],
            associatedRequestId: parentId,
            expectedCustomerFamilySubmissionId: selectedRequest.customerFamilySubmissionId,
            expectedCustomerFamilyGeneration: selectedRequest.customerFamilyGeneration
        };

        associateRequests(associationObject, {
            onSuccess: () => {
                setRequestProcessing(false);
                setDisplayScreen('successPopUp');

                AppQueryClient.invalidateQueries('getRequestById');
                AppQueryClient.invalidateQueries('useRequestList');
                AppQueryClient.invalidateQueries('requestQuery');
                AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            },
            onError: () => {
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        });
    };

    const handleAddAttachment = () => {
        setIsAddAttachmentModalOpen(true);
    };

    const resetEditableFields = () => {
        setResolutionDate(new Date(selectedRequest?.requestedResolutionDate?.toString()));
        setDescriptionTextToSubmit(selectedRequest?.description);
        setStatusSelection(selectedRequest?.status);
        setWhatBusinessProblemIsSolved(selectedRequest?.whatBusinessProblemIsSolved);
        setCompetitiveOffering(selectedRequest?.competitiveOffering);
        setIsDesignForSurfaceDFSPossible(selectedRequest?.isDesignForSurfacedPossible);
        setDcfJustification(selectedRequest?.dcfJustification);
        setDcfApprovedValue(selectedRequest?.dcfApprovedValue);
        setDcfSR(selectedRequest?.dcfSR);
        setCssCaseNumber(selectedRequest?.cssCaseNumber);
        setAnswer(selectedRequest?.answer);
        setDateImportantTextToSubmit(selectedRequest?.whyThisDateIsImportant);
        setTitle(selectedRequest?.summary);
        let companyInfo : ICompanyInformationDto = {
            companyContactName:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyContactName
                    ? selectedRequest?.companyInformation.companyContactName
                    : null,
            companyFullShippingAddress:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyFullShippingAddress
                    ? selectedRequest?.companyInformation.companyFullShippingAddress
                    : null,
            companyName:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.companyName
                    ? selectedRequest?.companyInformation.companyName
                    : null,
            contactEmailAddress:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.contactEmailAddress
                    ? selectedRequest?.companyInformation.contactEmailAddress
                    : null,
            contactPhoneNumber:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.contactPhoneNumber
                    ? getContactNumber(selectedRequest?.companyInformation.contactPhoneNumber)
                    : null,
            alternateContactNumber:
                selectedRequest?.companyInformation && selectedRequest?.companyInformation.alternateContactNumber
                    ? getContactNumber(selectedRequest?.companyInformation.alternateContactNumber)
                    : null
        };
        setCountryCodePrefix({
            contactNumber: getCountryCode(selectedRequest?.companyInformation?.contactPhoneNumber),
            alternateContactNumber: getCountryCode(selectedRequest?.companyInformation?.alternateContactNumber)
        });
        setCompanyInformation(companyInfo);
    };

    const handleShareRequest = () => {
        setIsShareRequestModalOpen(true);
    };

    const onCommentToggleChange = (ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        setIsShowComment(!checked);
    };

    const titleEdit = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setTitle((e.target as HTMLInputElement | HTMLTextAreaElement).value);
        setTitleFieldValue((e.target as HTMLInputElement | HTMLTextAreaElement).value);
        setIsInvalidTitle(false);
    };

    const bugInfoUpdateHandler = (data: BugInformations[]) => {
        setIsUpdateTriggered(true);
        let fieldData: RequestDto = new RequestDto();
        fieldData.init(selectedRequest);
        fieldData.bugInformations = data;
        setEditableFields((value: RequestDto) => ({ ...value, ...fieldData }));
    };

    const handleUpdateModalState = (value: boolean, associateSuccess: boolean) => {
        if (!value && associateSuccess) {
            AppQueryClient.invalidateQueries('useRequestList').then(() => {
                AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID).then(async () => {
                    await AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
                    await AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
                });
            });
        }

        setIsLinkRequestModalOpen(value);
    };

    // queries
    const {
        mutate: updateRequestMutation,
        isSuccess: isSuccessUpdate,
        isError: isErrorUpdate,
        isLoading: isLoadingUpdate
    } = useUpdateRequest();

    const {
        mutate: updateRequestDevicesMutation,
        isSuccess: isSuccessDeviceUpdate,
        isError: isErrorDeviceUpdate,
        isLoading: isLoadingDeviceUpdate
    } = useUpdateRequestDevices();

    // hooks
    useEffect(() => {
        resetEditableFields();
        if (selectedRequest?.assignee?.id) {
            setAssignedToSelection([
                {
                    id: selectedRequest?.assignee?.id,
                    displayName: selectedRequest?.assignee?.displayName,
                    mail: selectedRequest?.assignee?.email,
                    text: selectedRequest?.assignee?.displayName
                }
            ]);
        } else {
            setAssignedToSelection([
                {
                    id: '0',
                    displayName: StringConstants.UNASSIGNED,
                    text: StringConstants.UNASSIGNED
                }
            ]);
        }
    }, [selectedRequest, options]);
    useEffect(() => {
        if (!isUserListLoading && usersListData) {
            let arr: IUserProps[] = [];
            if (usersListData.filter((item: IUserProps) => item.id === userDetails.id).length !== 0) {
                arr.push({
                    id: userDetails.id,
                    displayName: userDetails.displayName,
                    mail: userDetails.email,
                    mobilePhone: userDetails.contactNumber,
                    businessPhones: userDetails.businessPhones,
                    text: '@Me'
                });
            }
            arr.push({
                id: '0',
                displayName: StringConstants.UNASSIGNED,
                text: StringConstants.UNASSIGNED,
                mail: StringConstants.UNASSIGNED
            });
            usersListData
                .filter((item: IUserProps) => item.id !== userDetails.id)
                .forEach((element: IUserProps) => {
                    arr.push({ ...element, text: element.displayName });
                });
            setOptions(arr);
        }
    }, [usersListData, isUserListLoading]);
    useEffect(() => {
        if (!isEditMode) {
            setCustomerDetailsValidation({
                contactNumberValidText: false,
                alternateContactValidText: false,
                emailValidText: false
            });
        }
    }, [isEditMode]);
    useEffect(() => {
        if (!isEditMode) {
            setIsEditMode(false);
            resetEditableFields();
        }
    }, [isEditMode]);
    useEffect(() => {
        setTitleFieldValue(title);
    }, [isEditMode]);

    useEffect(() => {
        setStatusSelection(selectedRequest?.status);
        setIsInvalidDescription(false);
        setIsShowComment(true);
        setSelectedTags(selectedRequest?.tags);
    }, [selectedRequest]);

    useEffect(() => {
        if (isSuccessUpdate || isSuccessDeviceUpdate || (isSuccessStatusUpdate && statusClosedSKPID !== '')) {
            setHideLoadingScreen(true);
            setIsStatusClosed(true);
            setStatusClosedSKPID('');
            setIsStatusClosed(false);
        }
        if ((!isLoadingUpdate || !isLoadingStatusUpdate || !isLoadingDeviceUpdate) && (isSuccessUpdate || isSuccessStatusUpdate || isSuccessDeviceUpdate)) {
            if (isEditMode) {
                setIsEditMode(false);
            }

            AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
            AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY).then(() => {
                if (isShowLoader && !isModalOpen) {
                    AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
                    setIsShowLoader(false);
                    toggleUpdateLoaderHideDialog();
                }
            });
        }

        if ((!isLoadingUpdate || !isLoadingStatusUpdate || !isLoadingDeviceUpdate) && (isErrorUpdate || isErrorStatusUpdate || isErrorDeviceUpdate)) {
            if (isShowLoader && !isModalOpen) {
                setIsShowLoader(false);
                toggleUpdateLoaderHideDialog();
            }
            showUpdateErrorModal();
        }
    }, [isSuccessUpdate, isErrorUpdate, isSuccessStatusUpdate, isErrorStatusUpdate, isLoadingStatusUpdate, isLoadingUpdate, isSuccessDeviceUpdate, isErrorDeviceUpdate, isLoadingDeviceUpdate]);

    useEffect(() => {
        if (!isTagsLoading) {
            setTagsListData(tagsData);
        }
    }, [isTagsLoading]);

    //add customer
    const addSuccessPopUp = useStore((state: IStore) => state.addSuccessPopUp);
    const addTagsRequest = () => {
        let addTag = {
            requestId: selectedRequest.unifiedTrackingId,
            selectedValues: selectedTags
        };
        addTagMutate(addTag);
    };

    useEffect(() => {
        setIsUpdateTriggered(false);
        initializeEditData();
    }, [selectedRequest, countryList]);

    useEffect(() => {
        if (isUpdateTriggered) {
            if (isShowLoader && !isModalOpen) {
                toggleUpdateLoaderHideDialog();
            }
            let dataToUpdate : RequestDto = generateEditData();
            let updateRequest : IUpdateRequestDto = {
                requestAction: RequestAction.Update,
                requestDto: dataToUpdate
            }
            updateRequestMutation(updateRequest);
            setIsUpdateTriggered(false);
        }
    }, [editableFields]);

    useEffect(() => {
        setIsStarred(selectedRequest?.isBookmarked);
    }, [selectedRequest?.isBookmarked]);

    const tooltipId = useId('tooltip');

    const tooltipProps: ITooltipProps = React.useMemo(
        () => ({
            onRenderContent: () => (
                <ul className="tags-list">
                    {selectedRequest &&
                        selectedRequest.tags &&
                        selectedRequest.tags?.slice(1).map((item) => (
                            <li>
                                <span className="tags-txt1">{item.name}</span>
                            </li>
                        ))}
                </ul>
            ),

            calloutProps: {
                styles: {
                    beak: { padding: '0' },
                    beakCurtain: { borderRadius: '13px', padding: '0' },
                    calloutMain: { borderRadius: '10px' }
                }
            }
        }),
        [selectedRequest]
    );

    useEffect(() => {
        if (!isLoadingAddBookmark && (isSuccessAddBookmark || isErrorAddBookMark)) {
            if (pageType === StringConstants.DETAILS_PAGE) {
                AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
            } else {
                AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
                AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            }
        }
        if (!isLoadingRemoveBookmark && (isSuccessRemoveBookmark || isErrorRemoveBookmark)) {
            if (pageType === StringConstants.DETAILS_PAGE) {
                AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
            } else {
                AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
                AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
            }
        }
    }, [
        isLoadingAddBookmark,
        isSuccessAddBookmark,
        isErrorAddBookMark,
        isLoadingRemoveBookmark,
        isSuccessRemoveBookmark,
        isErrorRemoveBookmark
    ]);

    useEffect(() => {
        const updateAttachmentCount = () => {
            setAttachmentCount(attachmentCounter(selectedRequest?.attachments, portal));
        };

        updateAttachmentCount();
    }, [selectedRequest]);

    const [hashTagsFormatted, setHashTagsFormatted] = useState<HashTagDto[]>([]);
    const { mutate: postHashTags } = usePostCommentsHashTags();

    useEffect(() => {
        if (isSuccessUpdate && selectedRequest) {
            let url = getURLForTeamAndType(selectedRequest.requestTeam, selectedRequest.requestType);
            if (Array.isArray(hashTagsFormatted) && hashTagsFormatted?.length > 0) {
                postHashTags({ url: url, data: hashTagsFormatted, id: selectedRequest.unifiedTrackingId });
            }
        }
    }, [isSuccessUpdate, selectedRequest]);

        // add sas token to storage urls in description and whyThisDateIsImportant
    const [selectedRequestDescription, setSelectedRequestDescription] = useState(selectedRequest?.description);
    const [selectedRequestWhyThisDateIsImportant, setSelectedRequestWhyThisDateIsImportant] = useState(selectedRequest?.whyThisDateIsImportant);
    useEffect(() => {
        const replaceStorageUrls = async () => {
            let description = await addBlobFileSasToken(Entity.REQUEST, BlobStorageContainer.REQUEST_DETAIL_FILES, selectedRequest?.description);
            setSelectedRequestDescription(description);

            let importance = await addBlobFileSasToken(Entity.REQUEST, BlobStorageContainer.REQUEST_DETAIL_FILES, selectedRequest?.whyThisDateIsImportant);
            setSelectedRequestWhyThisDateIsImportant(importance);
        }

        replaceStorageUrls();
    }, [selectedRequest])

    return (
        <>
            {isStatusClosed && (
                <div className="closed-status-banner">
                    Request {statusClosedSKPID} has been Closed. Please go to &nbsp;<span> Closed Request </span>&nbsp; tab to
                    view
                </div>
            )}
            <Modal isOpen={isMissingModalOpen} onDismiss={hideMissingModal} isBlocking={false} containerClassName="missing-modal">
                <div className="modal-heading">
                    <Text>Details missing</Text>
                    <IconButton
                        role="button"
                        className="modal-close"
                        iconProps={cancelIcon}
                        ariaLabel="Close missing popup modal"
                        onClick={handleModalDismiss}
                        onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, handleModalDismiss)}
                        tabIndex={0}
                    />
                </div>
                <div className="missing-modal-body">
                    <Text>
                        The below mentioned details are missing in the{' '}
                        <Link
                            onClick={() => {
                                handleModalDismiss();
                                setSelectedTab(StringConstants.CUSTOMER_INFORMATION);
                            }}>
                            Customer Information
                        </Link>{' '}
                        tab.
                    </Text>
                    <ul>
                        {missingDetails.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                    <Text>Navigate to the mentioned tab?</Text>
                    <div className="btn-cont">
                        <PrimaryButton
                            onClick={() => {
                                handleModalDismiss();
                                setSelectedTab(StringConstants.CUSTOMER_INFORMATION);
                            }}
                            text="Okay"
                        />
                    </div>
                </div>
            </Modal>
            <div className="details-panel-container">
                <div className="scroll-panel">
                    {selectedRequest && Object.keys(selectedRequest).length > 0 && (
                        <>
                            <div className="details-panel-wrapper">
                                <div className="dp-header">
                                    <div className="head-col-left">
                                        <Text className="dp-head-title">{selectedRequest.unifiedTrackingId}</Text>
                                        {renderTag(selectedRequest.status)}
                                        {renderAssociationTag()}
                                        <div className="dp-head-desc">
                                            {!isEditMode && (
                                                <TooltipHost content={selectedRequest.summary} id={tooltipId}>
                                                    <Text className="title-field">{selectedRequest.summary}</Text>{' '}
                                                </TooltipHost>
                                            )}
                                            {isEditMode && (
                                                <div className="m-b-20">
                                                    <TextField
                                                        value={isEditMode ? titleFieldValue : title}
                                                        placeholder="Enter title"
                                                        resizable={false}
                                                        borderless
                                                        onChange={(e) => titleEdit(e)}
                                                        className="editTitle"
                                                    />
                                                </div>
                                            )}

                                            {isInvalidTitle && (
                                                <div className="error-msg-block m-b-30">Please enter a valid title</div>
                                            )}
                                        </div>
                                        <div className="dp-head-user">
                                            <Text>
                                                <Trans>Team Assigned</Trans> :{' '}
                                                {selectedRequest.requestTeam ? UserDomain[selectedRequest.requestTeam as number] : ' --'}
                                            </Text>
                                            <Text className="dp-head-separator">|</Text>
                                            {selectedRequest.isParent ?
                                            <Text>
                                                <Trans>Number of Customers</Trans> :{' '}
                                                <Text>{selectedRequest.childrenCount}</Text>
                                            </Text> :
                                            <Text>
                                                <Trans>Customer</Trans> :{' '}
                                                <Text data-testid="admin-header-customer">
                                                    {isNewTicketViewEnabled
                                                        ? resolveCustomerSummaryText(selectedRequest, {
                                                              formatName: formatCustomerNames,
                                                              fallback: ' -- '
                                                          })
                                                        : selectedRequest?.customerImpacts?.length > 0 &&
                                                            selectedRequest.customerImpacts[0]?.customerName
                                                            ? formatCustomerSummary(
                                                                  selectedRequest.customerImpacts.map((customer) => ({
                                                                      accountName: customer.customerName
                                                                  })),
                                                                  formatCustomerNames
                                                              )
                                                            : ' -- '}
                                                </Text>
                                            </Text>}
                                            <Text className="dp-head-separator">|</Text>
                                            <Text>
                                                <Trans>Created On</Trans> :{' '}
                                                {ISOToDateTime(selectedRequest?.createdOn?.toString(), 'DD MMM YYYY')}
                                            </Text>
                                            <Text className="dp-head-separator">|</Text>
                                            <Text>
                                                <Trans>Submitted By</Trans> : {selectedRequest.createdBy?.displayName}
                                            </Text>
                                        </div>
                                    </div>
                                    <div className="head-col-right">
                                        {!isEditMode && !selectedRequest.isHidden && (
                                            <DefaultButton
                                                className="default add-cust-btn"
                                                data-testid="add-customer-button"
                                                onClick={() => {
                                                    setEditCustomer(undefined);
                                                    setDisplayScreen('searchCust');
                                                    setShowAddCustomerToast(false);
                                                    addSuccessPopUp(false);
                                                    showModal();
                                                }}>
                                                <Icon iconName="Add" className="m-r-5" /> <Text>Add Customer</Text>
                                            </DefaultButton>
                                        )}
                                        {hideModal && (
                                            <AddCustomerSurface
                                                testId="admin-details-add-customer"
                                                isEdit={!!editCustomer}
                                                isOpen={isModalOpen}
                                                onDismiss={hideModal}
                                                useDrawer={isNewTicketViewEnabled}
                                                enableEventBubbling>
                                                <AddImpact
                                                    selectedRequest={selectedRequest}
                                                    onDismiss={hideModal}
                                                    onSuccessHandler={handleAddCustomerSuccess}
                                                    globalSelectedRequest={selectedRequest}
                                                    setSelectedRequest={setSelectedRequest}
                                                    requestProcessing={requestProcessing}
                                                    setRequestProcessing={setRequestProcessing}
                                                    displayScreen={displayScreen}
                                                    setDisplayScreen={setDisplayScreen}
                                                    initialCustomer={editCustomer}
                                                    onEditSuccess={() => {
                                                        setEditCustomer(undefined);
                                                        setDisplayScreen('searchCust');
                                                        hideModal();
                                                    }}
                                                />
                                            </AddCustomerSurface>
                                        )}
                                        {showAddCustomerToast && (
                                            <AddCustomerSuccessToast
                                                customerName={toastCustomerName}
                                                onDismiss={() => setShowAddCustomerToast(false)}
                                            />
                                        )}
                                        {isEditMode && (
                                            <span className="form-btn-wrap">
                                                <DefaultButton className="default" onClick={handleCancelEdit}>
                                                    Cancel
                                                </DefaultButton>
                                                <DefaultButton className="primary m-l-10" onClick={handleSaveRequest}>
                                                    Save
                                                </DefaultButton>
                                            </span>
                                        )}
                                        <EllipseMenu
                                            isHidden={selectedRequest.isHidden}
                                            row={selectedRequest}
                                            origin={StringConstants.DETAIL_VIEW}
                                            isEditMode={isEditMode}
                                            setIsEditMode={setIsEditMode}
                                            rootIdName="grid-details-view-ellipse-id"
                                            setSelectedRequest={setSelectedRequest}
                                            page={pageNumber}
                                            setPage={setPageNumber}
                                        />
                                    </div>
                                </div>
                                <div></div>
                                <div className="dp-content">
                                    <div className="dp-details">
                                        <div className="shared-container">
                                            <AssignedToFilter
                                                selectedKeys={assignedToSelection}
                                                setSelectedKeys={setAssignedToSelection}
                                                origin={StringConstants.DETAILS_PANEL}
                                                options={options}
                                                selectedRequest={selectedRequest}
                                            />

                                            {tagsListData && (
                                                <div className="tags-block">
                                                    <span className="sperator-line"></span>
                                                    <div className="tag-icon-wrap">
                                                        <span className="tagSolidIcon"></span>
                                                        <Text> TAG(s) :</Text>
                                                    </div>

                                                    {selectedTags && (
                                                        <TagsList
                                                            options={tagsListData}
                                                            selectedKeys={selectedTags}
                                                            setSelectedKeys={setSelectedTags}
                                                            addTagsRequest={addTagsRequest}
                                                        />
                                                    )}
                                                    {selectedRequest?.tags?.length > 0 && (
                                                        <span className="tag-list">{selectedRequest?.tags[0]?.name} </span>
                                                    )}

                                                    {selectedRequest?.tags && selectedRequest?.tags.length > 1 && (
                                                        <span className="device-count-container">
                                                            <TooltipHost
                                                                tooltipProps={tooltipProps}
                                                                delay={TooltipDelay.zero}
                                                                id={tooltipId}
                                                                directionalHint={DirectionalHint.bottomCenter}
                                                                styles={hostStyles}
                                                                className="hostStyles-new">
                                                                <Text className="device-count">
                                                                    +{selectedRequest?.tags.length - 1}
                                                                </Text>
                                                            </TooltipHost>
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                            <div className="shared-actions">
                                                {!selectedRequest.isHidden && (
                                                    <span
                                                        className="shared-icon-container"
                                                        role="button"
                                                        tabIndex={0}
                                                        aria-pressed={isStarred}
                                                        aria-label={isStarred ? 'Unfavorite request' : 'Favorite request'}
                                                        onClick={onToggleBookmark}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') onToggleBookmark();
                                                        }}>
                                                        <Icon
                                                            title="Star icon"
                                                            aria-hidden="true"
                                                            iconName={isStarred ? `FavoriteStarFill` : 'FavoriteStar'}
                                                            className={`icon ${isStarred ? 'starred' : ''}`}
                                                        />
                                                    </span>
                                                )}

                                                <span
                                                    className="shared-icon-container"
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-label="Attachments"
                                                    onClick={handleAddAttachment}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') handleAddAttachment();
                                                    }}>
                                                    <i className="shared-icon attch-icon"></i>
                                                    <Text className="shared-txt">{attachmentCount}</Text>
                                                </span>
                                                {!selectedRequest.isHidden && (
                                                    <span
                                                        className="shared-icon-container mr-0"
                                                        role="button"
                                                        tabIndex={0}
                                                        aria-label="Share request"
                                                        onClick={handleShareRequest}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') handleShareRequest();
                                                        }}>
                                                        <i className="shared-icon share-icon"></i>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <DetailCard
                                            title={<Trans>Description</Trans>}
                                            useCardLayout={isNewTicketViewEnabled}
                                            legacyTitle={<Trans>DESCRIPTION</Trans>}>
                                        {isEditMode && (
                                            <div className="desc-textfield-wrap m-b-20">
                                                <RequestRichTextEditor
                                                    content={selectedRequestDescription}
                                                    hashTagsFormatted={hashTagsFormatted}
                                                    setHashTagsFormatted={setHashTagsFormatted}
                                                    setTextToSubmit={setDescriptionTextToSubmit}
                                                    fileStorageContainer={BlobStorageContainer.COMMENT_STATUS_FILES}
                                                />
                                            </div>
                                        )}
                                        {isInvalidDescription && (
                                            <div className="error-msg-block m-b-30">Please enter a description</div>
                                        )}
                                        {!isEditMode && !selectedRequest.description && '--'}
                                        {!isEditMode && (
                                            <div className="dp-content-text">
                                                <Text>
                                                    {selectedRequest.description && (
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: DOMPurify.sanitize(highlightTags(
                                                                    ReplaceUrlByAnchor(
                                                                        injectTargetToAnchor(selectedRequestDescription),
                                                                        'link-item',
                                                                        true
                                                                    )
                                                                ))
                                                            }}
                                                        ></span>
                                                    )}
                                                </Text>
                                            </div>
                                        )}
                                        </DetailCard>

                                        <ConfidentialIdentifier
                                            value={selectedRequest?.confidentialIdentifier}
                                            isVisible={isNewTicketViewEnabled}
                                        />

                                        <div className="pivot-container">
                                            {!isNewTicketViewEnabled && (
                                                <div className="pivot-header-container">
                                                    <Text>REQUEST INFORMATION :</Text>
                                                </div>
                                            )}
                                            <Pivot
                                                selectedKey={selectedTab}
                                                onLinkClick={(item) => setSelectedTab(item.props.itemKey)}>
                                                <PivotItem
                                                    className="tab-content"
                                                    itemKey={StringConstants.REQUEST_DETAILS}
                                                    itemID="request-details-tab"
                                                    headerText={'Request Details'}>
                                                    {!isLoading && (
                                                        <RequestDetailsTab
                                                            selectedRequest={selectedRequest}
                                                            requestDetailsLookup={requestDetailsLookup}
                                                            isEditMode={isEditMode}
                                                            resolutionDate={resolutionDate}
                                                            setResolutionDate={setResolutionDate}
                                                            statusMenu={statusMenu}
                                                            statusTypes={statusTypes}
                                                            statusSelection={statusSelection}
                                                            onCompleteHandler={onActionDropdownChangeHandler}
                                                            whatbusinessproblemissolved={whatBusinessProblemIsSolved}
                                                            setwhatbusinessproblemissolved={setWhatBusinessProblemIsSolved}
                                                            competitiveoffering={competitiveOffering}
                                                            setCompetitiveoffering={setCompetitiveOffering}
                                                            isdesignforsurfacedfspossible={isDesignForSurfaceDFSPossible}
                                                            setIsdesignforsurfacedfspossible={setIsDesignForSurfaceDFSPossible}
                                                            dcfJustification={dcfJustification}
                                                            setDcfJustification={setDcfJustification}
                                                            dcfApprovedValue={dcfApprovedValue}
                                                            setDcfApprovedValue={setDcfApprovedValue}
                                                            dcfSR={dcfSR}
                                                            setDcfSR={setDcfSR}
                                                            cssCaseNumber={cssCaseNumber}
                                                            setCssCaseNumber={setCssCaseNumber}
                                                            answer={answer}
                                                            setAnswer={setAnswer}
                                                            whyThisDateIsImportant={selectedRequestWhyThisDateIsImportant}
                                                            setTextToSubmit={setDateImportantTextToSubmit}
                                                            handleAddProduct={handleAddProduct}
                                                            hideLoadingScreen={hideLoadingScreen}
                                                            bugInfoUpdateHandler={bugInfoUpdateHandler}
                                                            hashTagsFormatted={hashTagsFormatted}
                                                            setHashTagsFormatted={setHashTagsFormatted}
                                                            isNewTicketViewEnabled={isNewTicketViewEnabled}
                                                        />
                                                    )}
                                                </PivotItem>
                                                <PivotItem
                                                    className="tab-content"
                                                    itemKey={StringConstants.CUSTOMER_INFORMATION}
                                                    itemID="customer-info-tab"
                                                    headerText={'Customer Information'}>
                                                    <CustomerDetailsTab
                                                        selectedRequest={selectedRequest}
                                                        toggleHideDialog={toggleHideDialog}
                                                        setImpactForRemoval={setImpactForRemoval}
                                                        isEditMode={isEditMode}
                                                        companyInformation={companyInformation}
                                                        setCompanyInformation={setCompanyInformation}
                                                        customerDetailsValidation={customerDetailsValidation}
                                                        setCustomerDetailsValidation={setCustomerDetailsValidation}
                                                        countyCodePrefix={countyCodePrefix}
                                                        setCountryCodePrefix={setCountryCodePrefix}
                                                        countryList={countryList}
                                                        onCompletedHandler={onCompletedHandler}
                                                        canManageCustomers
                                                        showCustomerCountHeader
                                                        onAddOrEditCustomer={(item?: IRemoveCustomerImpactData) => {
                                                            setEditCustomer(item);
                                                            setDisplayScreen(item ? 'addMultiDetails' : 'searchCust');
                                                            addSuccessPopUp(false);
                                                            showModal();
                                                        }}
                                                    />
                                                </PivotItem>
                                                <PivotItem
                                                    className="tab-content"
                                                    itemID="association-tab"
                                                    headerText={'Parent-Child Association'}>
                                                    <AssociationTab
                                                        setIsLinkRequestModalOpen={setIsLinkRequestModalOpen}
                                                        selectedRequest={selectedRequest}
                                                        setSelectedRequest={setSelectedRequest}
                                                        setIsAssociatingParent={setIsAssociatingParent}
                                                        setIsEditMode={setIsEditMode}
                                                        parent={parentRequest}
                                                    />
                                                </PivotItem>
                                                <PivotItem
                                                    className="tab-content"
                                                    itemID="comment-status-tab"
                                                    itemKey={StringConstants.COMMENTS_STATUS}
                                                    headerText={'Comment & Status'}>
                                                    <div className="comments-status-toggle-block">
                                                        <span
                                                            className={`${isShowComment ? 'active' : ''}`}
                                                            onClick={() => setIsShowComment(true)}>
                                                            Comment
                                                        </span>
                                                        <Toggle
                                                            checked={!isShowComment}
                                                            ariaLabel="status and comment switch"
                                                            onChange={onCommentToggleChange}
                                                        />{' '}
                                                        <span
                                                            className={`${!isShowComment ? 'active' : ''}`}
                                                            onClick={() => setIsShowComment(false)}>
                                                            Status
                                                        </span>
                                                    </div>
                                                    {isShowComment && selectedRequest.unifiedTrackingId && (
                                                        <CommentSection
                                                            correlationId={selectedRequest.unifiedTrackingId}
                                                            isMultipleType={true}
                                                            defaultIsInternal={true}
                                                            noExternalSection={selectedRequest.isHidden}
                                                            selectedRequest={selectedRequest}
                                                        />
                                                    )}
                                                    {!isShowComment && selectedRequest.unifiedTrackingId && (
                                                        <StatusSection
                                                            correlatedChildrenIds={
                                                                selectedRequest.isParent === true ? correlatedChildrenIds : []
                                                            }
                                                            correlationId={selectedRequest.unifiedTrackingId}
                                                            isMultipleType={true}
                                                            defaultIsInternal={true}
                                                            noExternalSection={selectedRequest.isHidden}
                                                            selectedRequest={selectedRequest}
                                                        />
                                                    )}
                                                </PivotItem>
                                            </Pivot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {isLoading && <Loader classNames="m-t-20 m-b-50 height-70" />}
                    {!isLoading && selectedRequest && Object.keys(selectedRequest).length === 0 && (
                        <div className="no-data">
                            <Trans>No data to display</Trans>
                        </div>
                    )}
                </div>
                {isAddAttachmentModalOpen && (
                    <AddAttachmentModal
                        modalState={isAddAttachmentModalOpen}
                        updateModalState={(value: boolean) => setIsAddAttachmentModalOpen(value)}
                        selectedRequest={getModalData(selectedRequest)}
                        entityType={1}
                        onCompletedHandler={onCompletedHandler}
                    />
                )}
                {isLinkRequestModalOpen && (
                    <LinkChildrenModal
                        modalState={isLinkRequestModalOpen}
                        updateModalState={handleUpdateModalState}
                        selectedRequest={selectedRequest}
                        entityType={1}
                        onCompletedHandler={onCompletedHandler}
                        setSelectedRequest={setSelectedRequest}
                        isAssociatingParent={isAssociatingParent}
                    />
                )}
                <RemoveCustomerDialog
                    automationPrefix="admin"
                    hidden={hideDialog}
                    isRemoving={isRemovingCustomer}
                    customerName={impactForRemoval.customerName}
                    hasError={removeCustomerError}
                    onDismiss={dismissRemoveCustomerDialog}
                    onConfirm={handleRemoveImpactConfirm}
                    className="remove-impact-confirmation"
                />
                <Dialog
                    hidden={hideUpdateLoaderDialog}
                    onDismiss={toggleUpdateLoaderHideDialog}
                    modalProps={{ isBlocking: false }}>
                    <Spinner size={SpinnerSize.large} label="Updating details. Please wait..." />
                </Dialog>

                <ShareRequestModal
                    modalState={isShareRequestModalOpen}
                    updateModalState={(value: boolean) => setIsShareRequestModalOpen(value)}
                    selectedRequest={selectedRequest}
                />

                <Modal
                    isOpen={isUpdateErrorModalOpen}
                    onDismiss={hideUpdateErrorModal}
                    isBlocking={false}
                    className="surface-modal notification-modal">
                    <div className="modal-header">
                        <span className="p-b-20"></span>
                    </div>
                    <div className="modal-body text-center">
                        <i className="ms-Icon ms-Icon--WarningSolid" aria-hidden="true"></i>
                        <h4 className="m-t-5 m-b-5">Something went wrong, please try again.</h4>
                    </div>
                    <div className="modal-footer">
                        <Button buttonClass="btn btn--primary" buttonText="OK" onClick={hideUpdateErrorModal} />
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default DetailsPanel;
